import React from "react";
import { Divider } from "../Controls";
import PageActions from "./PageActions";
import texts from "../../assets/strings/why.js";

import "./styles.less";

const WhyPage = () => (
  <div className="text-page why">
    <h1>{texts.title}</h1>
    <div
      className="page-content"
      dangerouslySetInnerHTML={{ __html: texts.html }}
    />
    <PageActions />
  </div>
);

export default WhyPage;



// WEBPACK FOOTER //
// ./components/Pages/Why.js